import { ChangeDetectorRef, Component, forwardRef, Inject, Input, OnInit } from '@angular/core';
import { ContractorRegistrationDecisionActivity } from 'src/app/models/activities/contractor-registration-decision-activity';
import { FormActivityEditorComponent } from '../form-activity-editor/form-activity-editor.component';
import { SecurityService, WorkflowContextService, WorkflowService } from 'src/app/services';
import { UntypedFormBuilder } from '@angular/forms';
import { DragulaService } from 'ng2-dragula';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'wm-contractor-renewal-decision-activity-editor',
    templateUrl: './contractor-renewal-decision-activity-editor.component.html',
    styleUrls: ['./contractor-renewal-decision-activity-editor.component.css'],
    standalone: false
})
export class ContractorRenewalDecisionActivityEditorComponent
  extends FormActivityEditorComponent
  implements OnInit {
    
  @Input() activity: ContractorRegistrationDecisionActivity;
  isGlobalAdmin: boolean;

  constructor(
    @Inject(forwardRef(() => WorkflowService)) workflowSvc: WorkflowService,
    @Inject(forwardRef(() => WorkflowContextService))
    context: WorkflowContextService,
    fb: UntypedFormBuilder,
    dragulaSvc: DragulaService,
    ref: ChangeDetectorRef,
    toastr: ToastrService,
    private _securitySvc: SecurityService
  ) {
    super(workflowSvc, context, toastr, fb, dragulaSvc, ref);
  }

  ngOnInit() {
        this._securitySvc.isSystemAdministrator().subscribe(isAdmin => {
      this.isGlobalAdmin = isAdmin;
    });
  }
}
